import { render } from "./RateFacility.vue?vue&type=template&id=967b0a84&scoped=true"
import script from "./RateFacility.vue?vue&type=script&lang=js"
export * from "./RateFacility.vue?vue&type=script&lang=js"

import "./RateFacility.vue?vue&type=style&index=0&id=967b0a84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-967b0a84"]])

export default __exports__